import { FC } from 'react';
import { TooltipProps } from './tooltip.type';
import { getIdAttributes } from '../../utils/helper';

const idPrefix: string = 'tooltip';

const Tooltip: FC<TooltipProps> = (props) => {
  const prefix: string = idPrefix;
  return (
    <div className="relative" {...getIdAttributes(prefix, 'container')}>
      <div className="group inline-block"></div>
      <div className="group inline-block">
        {props.children}
        <span
          {...getIdAttributes(prefix, 'content')}
          className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-2 text-xs text-white bg-black rounded-[10px] opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-20 whitespace-nowrap"
        >
          {props.tooltipContent}
        </span>
      </div>
    </div>
  );
};

export default Tooltip;
